import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useTranslation } from '../../../i18n/useTranslation.js';
import getHamburgerMenuData from '../../../server/actions/getHamburgerMenuData.js';
export default function useHamburgerMenuCategoryContentData(languageSwitcherItems, hamburgerData) {
    const router = useRouter();
    const { t } = useTranslation('hamburgerMenu');
    const languageSwitcherId = 'languageSwitcher';
    const [hamburgerMenuData, setHamburgerMenuData] = useState(() => {
        return {
            path: hamburgerData ? hamburgerData.url : '/',
            fadeInDirection: 'fromRight',
            sitemapData: hamburgerData,
        };
    });
    function languageSwitcherIsOpen(sitemapData) {
        return (sitemapData === null || sitemapData === void 0 ? void 0 : sitemapData.id) === languageSwitcherId;
    }
    function retrieveLanguageSwitcher() {
        setHamburgerMenuData((prevState) => {
            const getParents = (sitemapData) => {
                if (sitemapData) {
                    const { id, title, url, noFollow, presentationFormat } = sitemapData;
                    return { id, title, url, noFollow, presentationFormat };
                }
                return {
                    id: 'home',
                    title: t('allCategories'),
                    url: '/',
                    noFollow: false,
                    presentationFormat: '',
                };
            };
            return {
                path: '/',
                fadeInDirection: 'fromRight',
                sitemapData: {
                    presentationFormat: 'Visual presentation',
                    id: languageSwitcherId,
                    noFollow: true,
                    parents: [getParents(prevState.sitemapData)],
                    title: t('language'),
                    url: '/',
                    children: languageSwitcherItems.map(({ abbreviation, language, url, isCurrent }) => ({
                        title: `${language} (${abbreviation})`,
                        url,
                        isCurrent,
                        id: abbreviation,
                    })),
                },
            };
        });
    }
    function retrieveHamburgerPath(path, direction) {
        const fadeInDirection = direction === 'up' ? 'fromRight' : 'fromLeft';
        getHamburgerMenuData(path).then(res => {
            // If clicked on a child that has children but the call fails
            // or doesn't return anything: redirect user to clicked link
            if (res === undefined) {
                router.push(path);
            }
            else {
                setHamburgerMenuData({
                    path,
                    fadeInDirection,
                    sitemapData: res,
                });
            }
        });
    }
    return {
        hamburgerMenuData,
        retrieveLanguageSwitcher,
        retrieveHamburgerPath,
        languageSwitcherIsOpen,
    };
}
//# sourceMappingURL=useHamburgerCategoryContentData.js.map